import { lazy, useEffect } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { AttachmentsProvider } from "src/context/AttachmentsContext";
import { useUserData } from "src/context/userContext";

const AttachmentsLayout = lazy(() => import("src/pages/attachments/AttachmentsLayout"));

export default function AttachmentsCore() {
  const { userAsiakas, auth } = useUserData();

  useEffect(() => {
    if (import.meta.env.VITE_ISDEBUG === "yes") console.log("useEffect mount");
    document.title = "Liitetiedostot";
    const relUrl = window.location.pathname;
    localStorage.setItem("lastKnownUrl", relUrl);
  }, []);

  if (!auth.page.liite.list)
    return <div>Et ole oikeutettu näkemään tätä sivua (AttachmentsCore)</div>;

  return (
    <AttachmentsProvider ownerAsiakasId={userAsiakas?.asiakasId}>
      <LazyLoader>
        <AttachmentsLayout />
      </LazyLoader>
    </AttachmentsProvider>
  );
}
